<template>
  <div class="attachments-content">
    <div class="add-attachment" @click="openFileInput">
      <v-icon color="primary" x-large>mdi-attachment</v-icon>
      <span>Toque para adicionar um anexo</span>
      <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" :disabled="!canAdd" />
    </div>
    <div v-if="attachments.length" class="attachments">
      <div class="attachment" v-for="attachment in attachments" :key="attachment.id">
        <div class="attachment-icon">
          <v-icon color="grey">{{ handleAttachmentIcon(attachment.url) }}</v-icon>
        </div>
        <div class="attachment-info">
          <span class="attachment-name" @click="handleViewAttachment(attachment.url)">{{ attachment.description }}</span>
          <v-btn icon color="orange" @click="handleRenameAttachment(attachment)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>
        <div class="attachment-actions">
          <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="handleViewAttachment(attachment.url)">
                <v-list-item-icon><v-icon>mdi-open-in-app</v-icon></v-list-item-icon>
                <v-list-item-title>Abrir</v-list-item-title>
              </v-list-item>
              <v-list-item @click="handleToggleVisibility(attachment)">
                <v-list-item-icon><v-icon>mdi-eye-off-outline</v-icon></v-list-item-icon>
                <v-list-item-title>Alterar Visibilidade</v-list-item-title>
              </v-list-item>
              <v-list-item @click="handleDeleteAttachment(attachment)">
                <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
                <v-list-item-title style="color: red">Excluir</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <v-bottom-sheet v-model="isModalVisibilityActive" persistent>
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">Alterar Visibilidade</span>
          <v-btn icon @click="isModalVisibilityActive = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div class="visibility-toggle">
          <span>Visibilidade para o cliente</span>
          <v-switch
            v-model="attachmentToToggle.visible"
            color="primary"
            hide-details
            inset
            style="margin-top: 0px;"
          ></v-switch>
        </div>
        <v-btn color="primary" block @click="saveVisibility" class="mt-4">Salvar</v-btn>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: 'AttachmentsManager',
  emits: ['delete', 'rename', 'upload', 'toggle-visibility'],
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    canAdd: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isLoading: false,
      isModalVisibilityActive: false,
      attachmentToToggle: {
        id: null,
        description: null,
        visible: true
      },
      visibilityCache: {}
    };
  },
  methods: {
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        this.$emit('upload', selectedFile);
        this.$refs.fileInput.value = null;
      }
    },
    handleAttachmentIcon(url) {
      const extension = url.split('.').pop();
      const icons = {
        pdf: 'mdi-file-pdf-box',
        doc: 'mdi-file-document-outline',
        docx: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        xlsx: 'mdi-file-excel',
        ppt: 'mdi-file-powerpoint',
        pptx: 'mdi-file-powerpoint',
        jpg: 'mdi-file-image',
        jpeg: 'mdi-file-image',
        png: 'mdi-file-image',
        gif: 'mdi-file-image',
        mov: 'mdi-file-video',
        quicktime: 'mdi-file-video',
        mp4: 'mdi-file-video',
        default: 'mdi-file'
      };

      return icons[extension] || icons.default;
    },
    handleRenameAttachment(attachment) {
      this.$emit('rename', JSON.parse(JSON.stringify(attachment)));
    },
    handleDeleteAttachment(attachment) {
      this.$emit('delete', JSON.parse(JSON.stringify(attachment)));
    },
    handleToggleVisibility(attachment) {
      this.attachmentToToggle = JSON.parse(JSON.stringify(attachment));
      this.attachmentToToggle.visible =
        this.visibilityCache[attachment.id] !== undefined
          ? this.visibilityCache[attachment.id]
          : !!attachment.client_visible;
      this.isModalVisibilityActive = true;
    },
    saveVisibility() {
      this.$set(this.visibilityCache, this.attachmentToToggle.id, this.attachmentToToggle.visible);
      this.isModalVisibilityActive = false;
      this.$emit('toggle-visibility', JSON.parse(JSON.stringify(this.attachmentToToggle)));
    },
    handleViewAttachment(attachment) {
      // eslint-disable-next-line no-undef
      window.median.share.downloadFile({ url: attachment, open: true });
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-sheet-content {
  background-color: #fff;
  padding: 20px;

  .bottom-sheet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .bottom-sheet-title {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .visibility-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;

    span {
      font-size: 16px;
      color: #666;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 16px;
    }
  }
}

.attachments-content {
  .add-attachment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover {
      background-color: #f5f5f5;
    }

    span {
      margin-top: 10px;
      font-size: 16px;
      color: #999;
    }
  }

  .attachments {
    margin-top: 20px;

    .attachment {
      display: flex;
      align-items: center;
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin-bottom: 10px;
      transition: all 0.3s ease-in-out;

      &:hover {
        background-color: #f5f5f5;
      }

      .attachment-icon {
        margin-right: 10px;
      }

      .attachment-info {
        display: flex;
        align-items: center;
        overflow: hidden;

        .attachment-name {
          font-size: 16px;
          color: #999;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .attachment-actions {
        margin-left: auto;
      }
    }
  }
}
</style>
